import { useContext } from 'react';
import { PhoneContext, PhoneContextType } from '../contexts/phone_context';

const usePhone = () => {
    return useContext(PhoneContext) as PhoneContextType;
};

export default usePhone;
